import { Col, Input, Row, Select, Table } from "antd";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../components/functional_components/Button/PFButton";
import { ClearOutlined, DownloadOutlined, SearchOutlined } from "@ant-design/icons";
import { exportFile, showError } from "../../../utils/utilities";
import Vertical from "../../../services/api/Vertical";
import ExportConsolidatedProjects from "../../../services/api/ExportConsolidatedProjects";
import { useDispatch } from "react-redux";
import { setLoading } from "../../../redux/ducks/Loading";
import { get, isEmpty } from "lodash";
const ProjectsReport = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [state, setState] = useState({
    filterLoading: false,
    verticalsList: [],
    tableData: [],
  });
  const [stateSelectedRowKeys, setStateSelectedRowKeys] = useState([]);

  useEffect(() => {
    fetchVerticals();
  }, []);
  const fetchVerticals = async () => {
    const { error, data } = await Vertical.getVerticalList("allPages=true");
    if (error) {
      showError(error.messageCode || "ER000");
      return;
    }
    const options = data.map(({ id, name }) => ({ value: id, label: name }));
    setState((prevState) => ({
      ...prevState,
      verticalsList: options,
    }));
  };
  const formikFilter = useFormik({
    initialValues: {
      projectId: null,
      projectName: null,
      clientName: null,
      verticalId: null,
    },
    validate: (values) => {
      let errors = {};
      if (!values.projectId && !values.projectName && !values.clientName && !values.verticalId) {
        errors.projectId = "Required!";
      }
      return errors;
    },
    enableReinitialize: true,
    /**
     * @function onSubmit
     * @description Handle filter form submission
     * @param {Object} values - Form values
     * @returns {void}
     */
    onSubmit: async (values) => {
      setState((prevState) => ({ ...prevState, filterLoading: true }));
      // Filter out null values from the form
      Object.entries(values).forEach((element) => {
        if (element[1] === null) {
          delete values[element[0]];
        }
      });
      // Call the API to fetch the projects based on the filter values
      const { error, data } = await ExportConsolidatedProjects.searchProjects(values);

      // Handle errors
      if (error) {
        showError(error.messageCode || "ER000");
        return;
      }

      // Update the component state with the response data
      setState((prevState) => ({
        ...prevState,
        tableData: data,
        filterLoading: false,
      }));
    },
  });
  const rowSelection = {
    onChange: (selectedRowKeys) => setStateSelectedRowKeys(selectedRowKeys),
  };
  const doExport = async () => {
    dispatch(setLoading(true));
    const exportResponse = await ExportConsolidatedProjects.exportProjects({ ids: stateSelectedRowKeys });
    if (!exportResponse.error) {
      const blob = new Blob([exportResponse]);
      exportFile(blob, "project-consolidated-report.csv");
    } else {
      showError(get(exportResponse, "error.messageCode", "ER000"));
    }
    dispatch(setLoading(false));
  };
  return (
    <>
      <div className="filter-container">
        <Row type="flex" justify="start">
          <Col lg={6} md={12} xs={24} sm={10}>
            <Row>
              <label className="fw-bold mb-10" htmlFor="projectId">
                {t("reportCP.filter.projectId")}
              </label>
            </Row>
            <Row>
              <Col span={20}>
                <Input
                  id="projectId"
                  name="projectId"
                  allowClear
                  placeholder={t("reportCP.filter.projectId")}
                  onChange={formikFilter.handleChange}
                  onBlur={formikFilter.handleBlur}
                  value={formikFilter.values.projectId}
                />
              </Col>
            </Row>
          </Col>
          <Col lg={6} md={12} xs={24} sm={10}>
            <Row>
              <label className="fw-bold mb-10" htmlFor="projectName">
                {t("reportCP.filter.projectName")}
              </label>
            </Row>
            <Row>
              <Col span={20}>
                <Input
                  id="projectName"
                  name="projectName"
                  allowClear
                  placeholder={t("reportCP.filter.projectName")}
                  onChange={formikFilter.handleChange}
                  onBlur={formikFilter.handleBlur}
                  value={formikFilter.values.projectName}
                />
              </Col>
            </Row>
          </Col>
          <Col lg={6} md={12} xs={24} sm={10}>
            <Row>
              <label className="fw-bold mb-10" htmlFor="clientName">
                {t("reportCP.filter.clientName")}
              </label>
            </Row>
            <Row>
              <Col span={20}>
                <Input
                  id="clientName"
                  name="clientName"
                  allowClear
                  placeholder={t("reportCP.filter.clientName")}
                  onChange={formikFilter.handleChange}
                  onBlur={formikFilter.handleBlur}
                  value={formikFilter.values.clientName}
                />
              </Col>
            </Row>
          </Col>
          <Col lg={6} md={12} xs={24} sm={10}>
            <Row>
              <label className="fw-bold mb-10" htmlFor="vertical">
                {t("reportCP.filter.vertical")}
              </label>
            </Row>
            <Row>
              <Col span={20}>
                <Select
                  className="w-100"
                  id="verticalId"
                  name="verticalId"
                  placeholder={t("reportCP.filter.vertical")}
                  allowClear
                  onChange={(value) => formikFilter.setFieldValue("verticalId", value)}
                  onBlur={formikFilter.handleBlur("verticalId")}
                  value={formikFilter.values.verticalId}
                  options={state.verticalsList}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mt-1em" justify="end">
          <Col>
            <Button
              isDisabled={!(formikFilter.dirty && formikFilter.isValid)}
              type="secondary"
              currentSize="large"
              clickCallback={formikFilter.resetForm}
              currentIcon={<ClearOutlined className="icon-large" />}
            />
          </Col>
          <Col className="left-margin">
            <Button
              isDisabled={!(formikFilter.dirty && formikFilter.isValid)}
              currentSize="large"
              isLoading={state.filterLoading}
              clickCallback={formikFilter.submitForm}
              currentIcon={<SearchOutlined className="icon-large" />}
            />
          </Col>
          <Col className="left-margin">
            <Button
              isDisabled={isEmpty(stateSelectedRowKeys)}
              currentSize="large"
              isLoading={state.filterLoading}
              clickCallback={doExport}
              currentIcon={<DownloadOutlined className="icon-large" />}
            />
          </Col>
        </Row>
        <Row className="mt-1em" type="flex" justify="start">
          <Col span={24}>
            <Table
              rowKey={"projectId"}
              rowSelection={{
                type: "checkbox",
                ...rowSelection,
              }}
              columns={[
                {
                  title: t("reportCP.filter.projectId"),
                  dataIndex: "projectId",
                  key: "projectId",
                },
                {
                  title: t("reportCP.filter.projectName"),
                  dataIndex: "projectName",
                  key: "projectName",
                },
                {
                  title: t("reportCP.filter.clientName"),
                  dataIndex: "clientName",
                  key: "clientName",
                },
                {
                  title: t("reportCP.filter.vertical"),
                  dataIndex: "verticalName",
                  key: "verticalName",
                },
              ]}
              dataSource={state.tableData}
              pagination={false}
            />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ProjectsReport;
